"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterWithBadges = exports.Day = exports.DateWrapper = exports.DateContainer = exports.CardCalendarWrapper = exports.BadgeWrapper = exports.BadgeMultipleWrapper = void 0;
var _ykbStyledComponents = require("../../ykb-styled-components");
var _StyledDatePicker = require("../../DatePicker/StyledDatePicker");
var CardCalendarWrapper = exports.CardCalendarWrapper = (0, _ykbStyledComponents.styled)(_StyledDatePicker.StyledPickerPanelWrapper).withConfig({
  componentId: "ykb-ui__sc-jc2jn4-0"
})(["&-panel{", "}&-header{border-bottom:none !important;}&-footer{border-top:none !important;}&-date-panel{[class$='-body']{padding:0px !important;}[class$='-cell-inner']{display:flex !important;height:", " !important;}[class*='-in-view'][class*='-cell-today'] [class$='-cell-inner']:before{height:", " !important;}width:", " !important;table[class$='-content']{width:", " !important;td{cursor:default;}}}"], function (props) {
  return !props.borderless && (0, _ykbStyledComponents.css)(["box-sizing:border-box;border:1px solid ", ";border-radius:3px;border:1px solid #ccc;"], function (props) {
    return props.theme.color.grey6;
  });
}, function (props) {
  return props.theme.calendar.card.date.day.height;
}, function (props) {
  return props.theme.calendar.card.date.day.height;
}, function (props) {
  return props.$width || props.theme.calendar.card.width;
}, function (props) {
  return props.$width || props.theme.calendar.card.width;
});
var DateContainer = exports.DateContainer = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-jc2jn4-1"
})(["display:flex;flex-direction:column;align-items:center;height:", ";margin-left:auto;margin-right:auto;"], function (props) {
  return props.theme.calendar.card.date.height;
});
var DateWrapper = exports.DateWrapper = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-jc2jn4-2"
})(["display:flex;flex-direction:column;align-items:center;height:", ";margin-left:auto;margin-right:auto;"], function (props) {
  return props.theme.calendar.card.date.height;
});
var Day = exports.Day = _ykbStyledComponents.styled.span.withConfig({
  componentId: "ykb-ui__sc-jc2jn4-3"
})(["font-size:", ";line-height:", ";height:", ";display:flex;align-items:center;"], function (props) {
  return props.theme.calendar.card.date.day.fontSize;
}, function (props) {
  return props.theme.calendar.card.date.day.lineHeight;
}, function (props) {
  return props.theme.calendar.card.date.day.height;
});
var FooterWithBadges = exports.FooterWithBadges = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-jc2jn4-4"
})(["button{width:", ";margin-bottom:", ";}"], function (props) {
  return props.theme.calendar.card.footer.button.width;
}, function (props) {
  return props.theme.calendar.card.footer.button.marginBottom;
});
var BadgeWrapper = exports.BadgeWrapper = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-jc2jn4-5"
})(["display:flex;justify-content:center;div:not(:first-child){margin-left:", ";}"], function (props) {
  return props.theme.calendar.card.footer.badge.marginLeft;
});
var BadgeMultipleWrapper = exports.BadgeMultipleWrapper = _ykbStyledComponents.styled.div.withConfig({
  componentId: "ykb-ui__sc-jc2jn4-6"
})(["display:flex;gap:2px;justify-content:center;div:not(:first-child){margin-left:", ";}"], function (props) {
  return props.theme.calendar.card.footer.badge.marginLeft;
});